import React from 'react';

const PriceList = function () {
  return (
    <div className="priceList">
      <p>Die Mitgliederschaft bei PetPate.com ist für alle Nutzer kostenlos.</p>
      <h2>Tagespreise pro Tier im PATEN HAUSHALT</h2>
      <small>(z.B Hund, Katze, Pferd)</small>

      <ul>
        <li>PetPate: maximal 20.-
          <br /> Zusätzlich pro Nacht: maximal 5.-
        </li>
        <li>
  Premium PetPate: maximal 40.-<br />
 Zusätzlich pro Nacht: maximal 10.-
        </li>
        <li>
  Top-Premium PetPate: maximal 60.-<br />
 Zusätzlich pro Nacht: maximal 15.-
        </li>
      </ul>
      <h2>Tagespreise im BESITZER HAUSHALT</h2>
      <h3>pro Gattung/Käfig/Aquarium/Terrarium</h3>
      <small>(z.B Katzen zur Fütterung, Meerschweine, Fische)</small>
      <ul>
        <li>
  PetPate: maximal 10.-
        </li>
        <li>
  Premium und Top-Premium PetPate: maximal 20.-
          <br />
  1x Komplettreinigung pro Käfig/Toiletten/Aquarium/Terrarium etc: maximal 15.-
        </li>
      </ul>

      <p>
 Futter, Streu, Medikamente und alles was das Tier braucht, muss vom Besitzer gestellt werden
      </p>
      <br />
      <br />
      <h1>
 Warum die Betreuungszeit immer<br />
 über PetPate.com abschliessen?
      </h1>
      <p>
 Bewertungen/PetPfoten kannst Du nur abgeben und empfangen,<br />
 wenn Du die Patenzeit über PetPate.com gebucht hast.<br />
 Je mehr PetPfoten Du hast, desto vertrauenswürdiger wirkst Du<br />
 und deine Zusagen und Anfragen erhöhen sich,<br />
 weil deine Position in der Pet und Paten Suchliste steigt.<br />
      </p>
    </div>
  );
};

export default PriceList;



// WEBPACK FOOTER //
// ./src/pages/PriceList/index.js